import { ref } from 'vue'

const currentStep = ref(2)
const selectedCommissionLevel = ref(18)
const selectedPartner = ref(null)

export function useSetup() {
  const selectPartner = partner => {
    if (selectedPartner.value?.partnerId !== partner.partnerId) {
      selectedPartner.value = partner
    }
  }
  const resetSelectedPartner = () => {
    selectedPartner.value = null
  }

  const resetSetup = () => {
    currentStep.value = 2
    selectedCommissionLevel.value = null
  }

  const updateCommissionLevel = level => {
    selectedCommissionLevel.value = level
  }

  const setCurrentStep = step => {
    currentStep.value = step
  }

  return {
    currentStep,
    selectedCommissionLevel,
    selectedPartner,
    resetSetup,
    resetSelectedPartner,
    selectPartner,
    updateCommissionLevel,
    setCurrentStep,
  }
}
